import {customAxios, GENERIC_URL, IDUSUARIO, TOKEN, USERNAME} from '../constants';
import {CLEAR_VENDEDORES,CLEAR_SITUACIONES, FETCH_INMATRICULACION_SITUACION, FETCH_MAESTRO_TIPO_SOLICITUD_FACTURACION} from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchMaestroTipoSolicitudFacturacion(codGrupo) {
  const config = {
    headers: {
      codUsuario: USERNAME,
      idUsuario: IDUSUARIO
    },
    params: {
      codGrupo:codGrupo!==''? codGrupo:''
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_MAESTRO_TIPO_SOLICITUD_FACTURACION,
    payload: request,
  };
}

export function fetchSituacion(value) {
    console.log(value);
    const config = {
        params: {
            filtro:value,
        },
        headers: {
            codUsuario: USERNAME,
            idUsuario: IDUSUARIO,
            token: TOKEN,
        }
    };
    console.log(config);
    const request = customAxios.get(`${GENERIC_URL}/situacion/listar`, config)
    .then(({ data }) => evalAction(data, 'listar'))
    .catch(error => serverError(error, 'listar'))

    return {
        type: FETCH_INMATRICULACION_SITUACION,
        payload: request,
    };
}

export function clearSituaciones() {
    return {
        type: CLEAR_SITUACIONES,
    };
}



// WEBPACK FOOTER //
// ./src/actions/MaestroGenerico.js